import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiEnvironmentService } from './api-environment.service';
import { ApiMethodConstants } from './common/api-method.constants';
import { TransplantProgram } from './organ-transplant/organ-transplant.model';

@Injectable()
export class FilterService {
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiEnvironmentService
  ) { }

  public getFilteredText(filterOptions: any, url: string): string {
    //Handle filtered text
    if (filterOptions) {
      if (filterOptions['filteredText'] != undefined) {
        const healthCenters: string[] = [];

        for (let key of Object.keys(filterOptions)) {
          if (key === 'filteredText' && filterOptions[key]) healthCenters.push(filterOptions[key]);
        }

        let healthCenterString: string = '';
        for (var i = 0; i < healthCenters.length; i++) {
          if (i == healthCenters.length - 1) {
            healthCenterString += healthCenters[i];
          } else {
            healthCenterString += healthCenters[i] + ',';
          }
        }
        url += '&healthCenter=' + healthCenterString;
      }
    }

    return url;
  }

  public getTransplantPrograms() {    
    const apiBaseHref = this.apiService.getApiBaseHref();
    const url = `${apiBaseHref}/${ApiMethodConstants.Opo}/AllServiceTypes`;
    const headers = new HttpHeaders({
      Accept: '*/*'
    });
    return this.httpClient.get<TransplantProgram[]>(url, { headers: headers });
  }
}
